module.exports = __webpack_public_path__ + "static/media/subtitulo_productospanaderia.7d464d74.png";